import axios from "axios";

import { User } from "fe-shared/src/types/domain";
import { TokenResponse } from "types";

import config, { getApiHostUrl } from "config";
import { TenantOptions } from "fe-shared/src/types/domain/User";
import { getTenantHeaders, getAuthHeaders } from "fe-shared/src/helpers/tenantUtils";

export const getAccessToken = (): Promise<TokenResponse> => {
  const headers = getTenantHeaders();

  return axios
    .get(`${config.IDENTITY_HOST_URL}api/ExternalAccount/GetAccessToken`, {
      withCredentials: true,
      headers,
    })
    .then((res) => res.data);
};

export const getUserData = (token: string): Promise<User> => {
  const headers = getAuthHeaders(token);
  const apiBaseUrl = getApiHostUrl();

  return Promise.all([
    axios.get(`${apiBaseUrl}users/getInfo`, { headers }).then((res) => res.data),
    axios
      .get(`${apiBaseUrl}users/getPermissions`, { headers })
      .then((res) => res.data.permissions),
  ]).then(([userInfo, permissions]) => ({
    ...userInfo,
    permissions,
  }));
};

export const getTenantOptions = (token: string): Promise<TenantOptions> => {
  const headers = getAuthHeaders(token);
  const apiBaseUrl = getApiHostUrl();
  
  return axios
    .get(`${apiBaseUrl}getTenantOptions`, { headers })
    .then((res) => res.data);
};
